var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorWarningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15,
    width: 2,
    height: 10,
    transform: "rotate(-180 11 15)",
    fill: "#FEF0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 6L9.25 6L9.25 11L10.75 11L10.75 6ZM10.0044 12.5C9.79313 12.5 9.61458 12.5715 9.46875 12.7144C9.32292 12.8573 9.25 13.0344 9.25 13.2456C9.25 13.4569 9.32145 13.6354 9.46435 13.7812C9.60727 13.9271 9.78435 14 9.9956 14C10.2069 14 10.3854 13.9285 10.5313 13.7856C10.6771 13.6427 10.75 13.4656 10.75 13.2544C10.75 13.0431 10.6785 12.8646 10.5356 12.7187C10.3927 12.5729 10.2156 12.5 10.0044 12.5ZM9.99425 2C11.0953 2 12.1319 2.20833 13.1042 2.625C14.0764 3.04167 14.9271 3.61458 15.6563 4.34375C16.3854 5.07292 16.9583 5.92332 17.375 6.89496C17.7917 7.86661 18 8.90481 18 10.0095C18 11.1143 17.7917 12.1493 17.375 13.1146C16.9583 14.0799 16.3854 14.9271 15.6563 15.6562C14.9271 16.3854 14.0767 16.9583 13.105 17.375C12.1334 17.7917 11.0952 18 9.99046 18C8.88571 18 7.85069 17.7917 6.88542 17.375C5.92014 16.9583 5.07292 16.3854 4.34375 15.6562C3.61458 14.9271 3.04167 14.0783 2.625 13.1099C2.20833 12.1415 2 11.1068 2 10.0057C2 8.90469 2.20833 7.86805 2.625 6.89583C3.04167 5.92361 3.61458 5.07291 4.34375 4.34375C5.07292 3.61458 5.9217 3.04166 6.89008 2.625C7.85849 2.20833 8.89321 2 9.99425 2Z",
    fill: "#B42318"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWarningRed);
export default __webpack_public_path__ + "static/media/error_warning_red.82105ebcd56a7e2a7a23162b33165a6d.svg";
export { ForwardRef as ReactComponent };